export default "__VITE_ASSET__BBArD3h3__"